<template>
  <div class="tile" :class="{ small: small }" @click="$emit('click', data._id)">
    <div class="blank">
      <img :src="data.image" alt="" />
    </div>
    <h3>{{ data.name }}</h3>
    <p>{{ data.price }}</p>
  </div>
</template>

<script>
export default {
  name: "ProductTile",
  props: ["data", "prodId", "small"],
  data() {
    return {
      finalData: undefined,
      loaded: false
    };
  },
  methods: {
    async getProduct(id) {
      return new Promise(res => {
        this.axios.get(`product/${id}`).then(response => {
          res(response.data);
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.tile {
  display: inline-block;
  padding: 30px 20px;
  box-shadow: 4px 7px 21px -1px rgba(0, 0, 0, 0.75);
  transition-duration: 0.5s;

  &:hover {
    box-shadow: 8px 10px 21px -1px rgba(0, 0, 0, 0.75);
  }

  $imgsize: 150px;
  .blank {
    height: $imgsize;
    width: $imgsize;
    // background: grey;

    img {
      display: block;
      max-width: 100%;
      max-height: 100%;
      margin-left: auto;
      margin-right: auto;
    }
  }

  p {
    &::before {
      content: "Rs.";
    }
    &::after {
      content: "/-";
    }
  }
}

.small {
  padding: 10px 5px;
  // justify-content: space-evenly;

  $imgsize: 50px;
  .blank {
    margin: 0 auto;
    height: $imgsize;
    width: $imgsize;
  }
}
</style>
